import ReportFormData from "./ReportFormData";
import ReportFilter from "./ReportFilter";

const checkScamComponents = {
  ReportFormData,
  ReportFilter
}

export default checkScamComponents;